











































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Address } from '@/interface/api'
import { getZipCode } from '@/api/zip-code'
import { isPostalCode } from '@/utils/validate'
import { DeliveryInput } from './DeliveryInput'

@Component({
  components: { DeliveryInput }
})
export default class DeliveryForm extends Vue {
  @Prop({ required: true }) private value!: Address

  @Prop({ required: true, type: Boolean, default: false })
  private isConfirm!: boolean

  private errors = {
    postal_code: '',
    prefecture: '',
    city: '',
    other1: '',
    other2: ''
  }

  private get postal_code() {
    return this.value?.postal_code || ''
  }

  private set postal_code(v: string) {
    this.updateValue({ postal_code: v })
  }

  private get prefecture() {
    return this.value?.prefecture || ''
  }

  private set prefecture(v: string) {
    this.updateValue({ prefecture: v })
  }

  private get city() {
    return this.value?.city || ''
  }

  private set city(v: string) {
    this.updateValue({ city: v })
  }

  private get other1() {
    return this.value?.other1 || ''
  }

  private set other1(v: string) {
    this.updateValue({ other1: v })
  }

  private get other2() {
    return this.value?.other2 || ''
  }

  private set other2(v: string) {
    this.updateValue({ other2: v })
  }

  private get recipient_name() {
    return this.value?.recipient_name || ''
  }

  private set recipient_name(v: string) {
    this.updateValue({ recipient_name: v })
  }

  private updateValue(partial: Partial<Address>) {
    const next: Address = {
      postal_code: this.postal_code,
      prefecture: this.prefecture,
      city: this.city,
      other1: this.other1,
      other2: this.other2,
      recipient_name: this.recipient_name,
      ...partial
    }
    this.$emit('input', next)
  }

  public validate(): boolean {
    const a = this.onPostalcodeInput()
    const b = this.onPrefectureInput()
    const c = this.onCityInput()
    const d = this.onOther1Input()
    const e = this.onOther2Input()
    return !!(a && b && c && d && e)
  }

  private onPostalcodeInput() {
    if (!this.postal_code) {
      this.errors.postal_code = '必須項目です'
      return false
    }

    if (!isPostalCode(this.postal_code)) {
      this.errors.postal_code = '正しい郵便番号を入力してください'
      return false
    }

    this.errors.postal_code = ''
    return true
  }

  private onPrefectureInput() {
    if (!this.prefecture) {
      this.errors.prefecture = '必須項目です'
      return false
    } else if (this.prefecture.length > 45) {
      this.errors.prefecture = '45文字以内で入力してください'
      return false
    } else {
      this.errors.prefecture = ''
      return true
    }
  }

  private onCityInput() {
    if (!this.city) {
      this.errors.city = '必須項目です'
      return false
    } else if (this.city.length > 45) {
      this.errors.city = '45文字以内で入力してください'
      return false
    } else {
      this.errors.city = ''
      return true
    }
  }

  private onOther1Input() {
    if (!this.other1) {
      this.errors.other1 = '必須項目です'
      return false
    }
    // 番地には少なくとも1つ以上の数字が含まれていること
    if (!/\d/.test(this.other1)) {
      this.errors.other1 = '番地に数字を含めて入力してください'
      return false
    }
    const maxLength = 45
    if (this.other1.length > maxLength) {
      this.errors.other1 = `${maxLength}文字以内で入力してください`
      return false
    }
    this.errors.other1 = ''
    return true
  }

  private onOther2Input() {
    const maxLength = 45
    if (this.other2 && this.other2.length > maxLength) {
      this.errors.other2 = `${maxLength}文字以内で入力してください`
      return false
    } else {
      this.errors.other2 = ''
      return true
    }
  }

  private async getAddress(): Promise<void> {
    const zipCloudResponse = await getZipCode(this.postal_code)
    if (!zipCloudResponse) {
      this.errors.postal_code = '存在する郵便番号を入力してください'
      return
    }
    const next = {
      postal_code: zipCloudResponse[0].zipcode,
      prefecture: zipCloudResponse[0].address1,
      city: zipCloudResponse[0].address2,
      other1: zipCloudResponse[0].address3
    }
    this.updateValue(next)
    this.errors.postal_code = ''
    this.errors.prefecture = ''
    this.errors.city = ''
    this.errors.other1 = ''
  }
}
